import styled from 'styled-components'

export const StyledButton = styled.button`
   padding: ${({ variant }) => variant === 'outline' ? '6.5px 13px' : '13px 24.5px'};
   margin: 0;
   border: none;
   border-radius: 6px;
   font-size: ${({ variant }) => variant === 'outline' ? '12px' : '16px'};
   line-height: ${({ variant }) => variant === 'outline' ? '160%' : '1'};
   font-weight: ${({ variant }) => variant === 'outline' ? '400' : '450'};
   cursor: pointer;
   display: inline-block;
   color: ${({ theme }) => (theme?.darkMode ? theme.colors.buttonTextColor : theme.colors.textColor)};
   display: flex;
   align-items: center;
   justify-content: center;
   width: fit-content;
   box-sizing: border-box;

   && > span,
   && span:not([class]) {
      font-size: ${({ variant }) => variant === 'outline' ? '12px' : '16px'};
      line-height: 1;
      font-weight: 450;
      letter-spacing: 0;
      text-transform: none;
      display: inline-block;
      height: 14px;
      transform: translateY(-1px);
   }

   font-family: ${({ variant, theme }) => {
      switch (variant) {
         case 'dark':
            return theme.fonts.portrait
         case 'light':
            return theme.fonts.portrait
         case 'orange':
            return theme.fonts.portrait
         case 'outline':
            return theme.fonts.sohne
         default:
            return theme.fonts.portrait
      }
   }};

   background-color: ${({ variant, theme }) => {
      switch (variant) {
         case 'dark':
            return theme.colors.btnDarkBg
         case 'light':
            return theme.colors.btnLightBg
         case 'orange':
            return theme.colors.btnOrangeBg
         case 'outline':
            return theme.colors.btnOutlineBg
         default:
            return 'transparent'
      }
   }};

   color: ${({ variant, theme }) => {
      switch (variant) {
         case 'dark':
            return theme.colors.btnDarkColor
         case 'light':
            return theme.colors.btnLightColor
         case 'orange':
            return theme.colors.btnOrangeColor
         case 'outline':
            return theme.colors.btnOutlineColor
      }
   }};

   &:hover {
      background-color: ${({ variant, theme }) => {
         switch (variant) {
            case 'dark':
               return theme.colors.btnDarkBgHover
            case 'light':
               return theme.colors.btnLightBgHover
            case 'orange':
               return theme.colors.btnOrangeBgHover
            case 'outline':
               return theme.colors.btnOutlineBgHover
            default:
               return 'transparent'
         }
      }} !important;

      color: ${({ variant, theme }) => {
         switch (variant) {
            case 'dark':
               return theme.colors.btnDarkColor
            case 'light':
               return theme.colors.btnLightColor
            case 'orange':
               return theme.colors.btnOrngeColor
            case 'outline':
               return theme.colors.btnOutlineColor
         }
      }} !important;
   }

   &:active {
      background-color: ${({ variant, theme }) => {
         switch (variant) {
            case 'dark':
               return theme.colors.btnDarkBgFocus
            case 'light':
               return theme.colors.btnLightBgFocus
            case 'orange':
               return theme.colors.btnOrangeBgFocus
            case 'outline':
               return theme.colors.btnOutlineBgFocus
         }
      }} !important;
   }

   &:disabled {
      ${({ variant, theme, disabled }) => {
         if (!disabled) return

         switch (variant) {
            case 'orange':
               return `
                  background-color: ${theme.colors.btnOrangeBgDisabled};
                  color: ${theme.colors.btnOrangeColor};
               `

            case 'outline':
               return `
                  background-color: ${theme.colors.btnOutlineBgDisabled};
                  color: ${theme.colors.btnOutlineColorDisabled};
                  border: none;
               `

            default:
               return `
                  background-color: ${theme.colors.btnBgDisabled};
                  color: ${theme.colors.btnColorDisabled};
               `
         }
      }}
      cursor: not-allowed;
   }
`
